export default "__VITE_ASSET__Db86mIjh__"